export default __webpack_public_path__ + "static/media/chibuzor.923cc3fd.jpg";